export const COUNTRIES = {
    iso: {
        RU: 'Россия',
        KZ: 'Казахстан',
        BY: 'Беларусь',
        UZ: 'Узбекистан',
        AZ: 'Азербайджан',
    },
}
